/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from "react-router-dom"
import { Route, Switch } from "react-router-dom"
import Image from './UiComponent/Image'
import FormPage from './page/FormPage.js'
import SuccessPage from './page/SuccessPage.js'
import './css/layout.scss';
import './RootRouter.scss';
import NotFound from './page/NotFound.js';
import ECertPage from './page/eCertPage.js';
import Payment from './page/Payment.js';
class RootRouter extends Component {

	constructor(props) {
		super(props)
		this.state = {
			isLoading: false
		}
		this.hideShowLoading = this.hideShowLoading.bind(this);
	}

	componentDidMount() {
		if (this.props.location.pathname == '/') {
			this.props.history.replace(window.info.config.pathname + "/application.html")
		}
		else if (this.props.location.pathname == window.info.config.pathname + '/' || this.props.location.pathname == window.info.config.pathname) {
			this.props.history.replace(window.info.config.pathname + "/application.html")
		}
	}

	componentWillUnmount() {
	}

	hideShowLoading(action) {
		if (action == "hide") {
			this.setState({ isLoading: false })
		} else if (action == "show") {
			this.setState({ isLoading: true })
		}
	}
	onBackToMainClicked() {
		location.href = 'http://www.rollersports.com.hk/';
	}

	render() {
		return (
			<div id="RootRouter">
				{this.state.isLoading && (
					<div id='loading-overlay' >
						<Image className='loading-icon' src='/img/loading.gif' />
					</div>
				)}
				<div className='form-header'>
					<div className='clickable-div' onClick={() => this.onBackToMainClicked()}>
						<Image className='header-image' src='/img/hkisa-icon.png' />
					</div>
					<div className='header-title clickable-div' onClick={() => this.onBackToMainClicked()}>Hong Kong Inline Skating Association HKISA</div>
					<div className='header-desc'>Event Application System</div>

				</div>
				<Switch>
					<Route path={window.info.config.pathname + "/application.html"} render={(props) => (
						<React.Fragment>
							<FormPage rootHideShowLoading={this.hideShowLoading} />
						</React.Fragment>
					)} />
					<Route path={window.info.config.pathname + "/success.html"} render={(props) => (
						<React.Fragment>
							<SuccessPage {...props} />
						</React.Fragment>
					)} />

					<Route path={"/entry/ecert/search.html"} render={(props) => (
						<React.Fragment>
							<ECertPage {...props} rootHideShowLoading={this.hideShowLoading} />
						</React.Fragment>
					)} />
					<Route path={window.info.config.pathname + "/payment.html"} render={(props) => (
						<React.Fragment>
							<Payment {...props} rootHideShowLoading={this.hideShowLoading} />
						</React.Fragment>
					)} />				
					
					<Route render={(props) => (
						<React.Fragment>
							<NotFound />
						</React.Fragment>
					)} />
				</Switch>
			</div>
		);
	}


}

export default withRouter(RootRouter);